
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addPriceMin,
  addPriceMax,
  addAreaMin,
  addAreaMax,
  addBuiltYearMin,
  addBuiltYearMax,
  addBathrooms,
  addBedrooms,
  resetOccupancy,
  addOccupancy,
  setPageNumber,
} from "../../redux/SRP/propertiesSlice";
import close from '../../../public/assets/images/srp/close.svg';
import downArrow from '../../../public/assets/images/down-arrow.svg';
import FilterSingleItem from "./FilterSingleItem";
import { trackButtonClick } from "@/utils/analytics";
import { trackFilterInteraction, getSrpLocationLabel } from "@/utils/filterTrackingService";

const FilterMoreItem = ({panelId, panelBodyId, propertyName, disabledList, disabledFilter, isMobView = false, onClearPress}) => {
  const {
    bathrooms,
    bedrooms,
    price,
    area,
    builtYear,
    occupancyStatus,
    pageNumber
  } = useSelector((state) => state.properties);
  const srpFilterInitData = useSelector((state) => state.srpFilter.srpFilterInitData);
  const [show, setShow] = useState(false)

  const propertyCount = 0 +
   ((price.min > 0 || price.max > 0) ? 1 : 0) +
    (area.min.length > 0 || area.max.length > 0 ? 1 : 0) +
    (builtYear.min > 0 || builtYear.max > 0 ? 1 : 0) +
    (bedrooms.length > 0 ? 1 : 0) + (bathrooms.length > 0 ? 1 : 0);
  const dispatch = useDispatch();

  const queryParams = new URLSearchParams(window.location.search);
  //set PriceRange
  const URLPriceRange = queryParams.get("priceRange")?.split('-');
  const URLPriceMin = URLPriceRange?.length > 0 ? URLPriceRange[0] : false;
  const URLPriceMax = URLPriceRange?.length > 1 ? URLPriceRange[1] : false;
  if (URLPriceMin && price.min !== Number(URLPriceMin)) {
    dispatch(addPriceMin(Number(URLPriceMin)));
  }
  if (URLPriceMax && price.max !== (URLPriceMax === '1000000plus' ? 1000001 : Number(URLPriceMax))) {
    dispatch(addPriceMax(URLPriceMax === '1000000plus' ? 1000001 : Number(URLPriceMax)));
  }
  //set squareFeetRange
  const URLAreaRange = queryParams.get("squareFeetRange")?.split('-');
  const URLAreaMin = URLAreaRange?.length > 0 ? URLAreaRange[0] : false;
  const URLAreaMax = URLAreaRange?.length > 1 ? URLAreaRange[1] : false;
  if (URLAreaMin && area.min !== URLAreaMin) {
    dispatch(addAreaMin(URLAreaMin));
  }
  if (URLAreaMax && area.max !== (URLAreaMax === '10000plus' ? 10001 : Number(URLAreaMax))) {
    dispatch(addAreaMax(URLAreaMax === '10000plus' ? 10001 : Number(URLAreaMax)));
  }
  //set yearBuiltRange
  const URLYearBuiltRange = queryParams.get("yearBuiltRange")?.split('-');
  const URLYearBuiltMin = URLYearBuiltRange?.length > 0 ? URLYearBuiltRange[0] : false;
  const URLYearBuiltMax = URLYearBuiltRange?.length > 1 ? URLYearBuiltRange[1] : false;
  if (URLYearBuiltMin && builtYear.min !== ((URLYearBuiltMin === 'Before%201800' || URLYearBuiltMin === 'Before 1800') ? 1799 : Number(URLYearBuiltMin))) {
    dispatch(addBuiltYearMin((URLYearBuiltMin === 'Before%201800' || URLYearBuiltMin === 'Before 1800') ? 1799 : Number(URLYearBuiltMin)));
  }
  if (URLYearBuiltMax && builtYear.max !== ((URLYearBuiltMax === 'After%202010' || URLYearBuiltMax === 'After 2010') ? 2011 : Number(URLYearBuiltMax))) {
    dispatch(addBuiltYearMax((URLYearBuiltMax === 'After%202010' || URLYearBuiltMax === 'After 2010') ? 2011 : Number(URLYearBuiltMax)));
  }
  //set bed
  const URLBed = queryParams.get("bed");
  if (URLBed && bedrooms !== URLBed) {
    dispatch(addBedrooms(URLBed));
  }
  //set bath
  const URLBath = queryParams.get("bath");
  if (URLBath && bathrooms !== URLBath) {
    dispatch(addBathrooms(URLBath));
  }

useEffect(() => {
  const handleClick = (event) => {
    const panelBtn = document.getElementById(`${panelId}-btn`);
    const panelArea = document.getElementById(panelBodyId);
    if (
      (panelBtn && panelBtn.contains(event.target) && !show) ||
      (panelArea && panelArea.contains(event.target))
    ) {
      setShow(true);
      // Track dropdown open event
      if (!show) {
        if (!window._processingStateOpen) {
          window._processingStateOpen = true;

          trackButtonClick({
            eventName: "filter_dropdown_open",
            eventParams: { property_name: propertyName },
            eventSource: "Dropdown Interaction",
            eventCategory: "NEW-SRP",
            eventLabel: `Location: ${getSrpLocationLabel()}`,
          });

          // Reset the processing flag after a short delay
          setTimeout(() => {
            window._processingStateOpen = false;
          }, 300);
        }
      }
    } else {
      setShow(false);
    }
  };

  document.addEventListener("click", handleClick);

  // Clean up the event listener
  return () => {
    document.removeEventListener("click", handleClick);
  };
}, [show, panelId, panelBodyId, propertyName]);


  const FilterItem = ({name, onChange, value, optionsMin, optionsMax, isSingleItem, defaultMax}) => {
    if (isSingleItem) {
      return (
        <>
          <div className="panel p0 mb5">
            <div className="panel-heading">
              <div className="title-filter">
                <span>{name}</span>
              </div>
            </div>
          </div>
          <select
            onChange={(e) => onChange(e.target.value)}
            className="selectpicker w100 show-tick form-select mb25"
            style={{paddingLeft: 10}}
            value={value || 5}
            key={name}
          >
            {optionsMin}
          </select>
        </>
      )
    }
    return (
      <>
        <div className="panel p0 mb5">
          <div className="panel-heading">
            <div className="title-filter">
              <span>{name}</span>
            </div>
          </div>
        </div>
        <div className="row p0 m0 justify-content-between">
          <select
            onChange={(e) => onChange({value: e.target.value, field: 'min'})}
            className="selectpicker w100 show-tick form-select panel-width mb25"
            style={{paddingLeft: 5}}
            value={value.min}
            key={`min-${name}`}
          >
            {optionsMin}
          </select>
          <select
            onChange={(e) => onChange({value: e.target.value, field: 'max'})}
            className="selectpicker w100 show-tick form-select panel-width mb25"
            style={{paddingLeft: 5}}
            value={value.max || defaultMax}
            key={`max-${name}`}
          >
            {optionsMax}
          </select>
        </div>
      </>
    );
  }

  const getFilterComponent = () => {
    const FilterComponent = [];
    srpFilterInitData.map((filterList) => {
      if (filterList.name === "Price Range" && !disabledList.includes(filterList.fieldIDUI)) {
        const propertyList = filterList?.sliderContents?.sliderSteps?.sliderSteps;
        const propertyUnit = filterList?.unit || '$';
        const getOptionsMin = () => {
          return propertyList?.filter((item) => price?.max > 0 ? item?.value < price?.max ? item : false : item)
          ?.map((item, index) => index < propertyList.length - 1
          ? <option key={item?.value} value={item?.value}>{item?.value ? propertyUnit + item?.display : 'No Minimum'}</option>
          : null);
        };
        const getOptionsMax = () => {
          const list = propertyList?.filter((item) => item?.value === 0 ? false : price?.min > 0 ? item?.value > price?.min ? item : false : item)?.slice(0);
          return [...list.slice(list.length - 1), ...list.slice(0, list.length - 1)]?.map((item) => <option value={item?.value} key={item?.value}>{item?.value !== 1000001 ? propertyUnit + item?.display : 'No Maximum'}</option>);
        };
        FilterComponent[1] = (
          <FilterItem
            name={filterList?.name}
            key={filterList?.name}
            onChange={({value, field}) => {
              if (field === 'min') {
                // update Addressbar
                let addressBarURL = new URL(window.location.href);
                if (addressBarURL.searchParams.has("priceRange")) {
                  addressBarURL.searchParams.delete('priceRange')
                  addressBarURL.searchParams.append('priceRange', `${value || '0'}-${!price.max || price.max === 1000001 ? '1000000plus' : price.max}`)
                  history.pushState({}, '', addressBarURL.href)
                } else {
                  addressBarURL.searchParams.append('priceRange', `${value || '0'}-${!price.max || price.max === 1000001 ? '1000000plus' : price.max}`)
                  history.pushState({}, '', addressBarURL.href)
                }
                //update Redux
                if (pageNumber !== 1) dispatch(setPageNumber(1));
                dispatch(addPriceMin(Number(value)));

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_price_range",
                  eventSource: "Price range filter change",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Price Range:${
                    value || "0"
                  }-${
                    !price.max || price.max === 1000001
                      ? "1000000plus"
                      : price.max
                  } | Location: ${getSrpLocationLabel()}`,
                });
              } else {
                //update Addressbar
                let addressBarURL = new URL(window.location.href);
                if (addressBarURL.searchParams.has("priceRange")) {
                  addressBarURL.searchParams.delete('priceRange')
                  addressBarURL.searchParams.append('priceRange', `${price.min || '0'}-${!value || value === '1000001' ? '1000000plus' : value}`)
                  history.pushState({}, '', addressBarURL.href)
                } else {
                  addressBarURL.searchParams.append('priceRange', `${price.min || '0'}-${!value || value === '1000001' ? '1000000plus' : value}`)
                  history.pushState({}, '', addressBarURL.href)
                }
                //update Redux
                if (pageNumber !== 1) dispatch(setPageNumber(1));
                dispatch(addPriceMax(Number(value)));

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_price_range",
                  eventSource: "Price range filter change",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Price Range:${
                    price.min || "0"
                  }-${
                    !value || value === "1000001" ? "1000000plus" : value
                  } | Location: ${getSrpLocationLabel()}`,
                });
            }}}
            value={price}
            optionsMin={getOptionsMin()}
            optionsMax={getOptionsMax()}
            // optionsMax={propertyList?.filter((item) => item?.value === 0 ? false : price?.min > 0 ? item?.value > price?.min ? item : false : item)
            //   ?.slice(0)?.reverse()?.map((item) => <option value={item?.value} key={item?.value}>{item?.value !== 1000001 ? propertyUnit + item?.display : 'No Maximum'}</option>)}
          />
        )
      } else if (filterList.fieldIDUI === 'occupancyStatus' && !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        FilterComponent[0] = (
          <div className="w-100 p0">
          <FilterSingleItem
            panelId={filterList.fieldIDUI + '-more'}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            selectedList={occupancyStatus}
            onClick={(item) => {
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              const isAlreadySelected = occupancyStatus.includes(item.uiurl);
              dispatch(addOccupancy(item.uiurl))

              // Track via API
              trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                isAlreadySelected ? { deselectedFilters: `occupancyStatus=${item.uiurl}` } : {}
              );

              trackButtonClick({
                eventName: "filters_occupancy_status",
                eventSource: "Filter select",
                eventCategory: "NEW-SRP",
                eventLabel: `Occupancy Status:${item?.displayname} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href)
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "occupancyStatus") {
                  addressBarURL.searchParams.delete("occupancyStatus")
                }
              })
              history.pushState({}, "", addressBarURL.href)
              if (pageNumber !== 1) dispatch(setPageNumber(1));

              // Track via API - pass all deselected values before clearing
              trackFilterInteraction('FILTER_DESELECTED', {
                deselectedFilters: occupancyStatus.map(v => `occupancyStatus=${v}`).join(',')
              });

              dispatch(resetOccupancy());
            }}
            disabledFilter={disabledFilter}
            isMobView={isMobView}
          />
          </div>
        )
      } else if (filterList.name === "Area (in Sq Ft)" && !disabledList.includes(filterList.fieldIDUI)) {
        const propertyList = filterList?.sliderContents?.sliderSteps?.sliderSteps;
        const propertyUnit = (filterList?.unit || 'sq ft').toLowerCase();
        const getOptionsMin = () => {
          return propertyList?.filter((item) => area?.max > 0 ? item?.value < area?.max ? item : false : item)
          ?.map((item, index) => index < propertyList.length - 1
          ? <option key={item?.value} value={item?.value}>{item?.value ? item?.display + ' ' + propertyUnit : 'No Minimum'}</option>
          : null);
        };
        const getOptionsMax = () => {
          const list = propertyList?.filter((item) => item?.value === 0 ? false : area?.min > 0 ? item?.value > area?.min ? item : false : item)?.slice(0);
          return [...list.slice(list.length - 1), ...list.slice(0, list.length - 1)]?.map((item) => <option value={item?.value} key={item?.value}>{item?.value !== 10001 ? item?.display + ' ' + propertyUnit : 'No Maximum'}</option>);
        };
        FilterComponent[4] = (
          <FilterItem
            name={"Square Footage" || filterList?.name}
            key={filterList?.name}
            onChange={({value, field}) => {
              if (field === 'min') {
                // update Addressbar
                let addressBarURL = new URL(window.location.href);
                if (addressBarURL.searchParams.has("squareFeetRange")) {
                  addressBarURL.searchParams.delete('squareFeetRange')
                  addressBarURL.searchParams.append('squareFeetRange', `${value || '0'}-${!area.max || area.max === 10001 ? '10000plus' : area.max}`)
                  history.pushState({}, '', addressBarURL.href)
                } else {
                  addressBarURL.searchParams.append('squareFeetRange', `${value || '0'}-${!area.max || area.max === 10001 ? '10000plus' : area.max}`)
                  history.pushState({}, '', addressBarURL.href)
                }
                //update Redux
                if (pageNumber !== 1) dispatch(setPageNumber(1));
                dispatch(addAreaMin(Number(value)));

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_square_footage",
                  eventSource: "Filter select",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Square Footage:${
                    value || "0"
                  }-${
                    !area.max || area.max === 10001 ? "10000plus" : area.max
                  } | Location: ${getSrpLocationLabel()}`,
                });
              } else {
                //update Addressbar
                let addressBarURL = new URL(window.location.href);
                if (addressBarURL.searchParams.has("squareFeetRange")) {
                  addressBarURL.searchParams.delete('squareFeetRange')
                  addressBarURL.searchParams.append('squareFeetRange', `${area.min || '0'}-${!value || value === '10001' ? '10000plus' : value}`)
                  history.pushState({}, '', addressBarURL.href)
                } else {
                  addressBarURL.searchParams.append('squareFeetRange', `${area.min || '0'}-${!value || value === '10001' ? '10000plus' : value}`)
                  history.pushState({}, '', addressBarURL.href)
                }
                //update Redux
                if (pageNumber !== 1) dispatch(setPageNumber(1));
                dispatch(addAreaMax(Number(value)));

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_square_footage",
                  eventSource: "Filter select",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Square Footage:${
                    area.min || "0"
                  }-${
                    !value || value === "10001" ? "10000plus" : value
                  } | Location: ${getSrpLocationLabel()}`,
                });
              }
            }}
            value={area}
            optionsMin={getOptionsMin()}
            optionsMax={getOptionsMax()}
          />
        )
      } else if (filterList.name === "Year Built" && !disabledList.includes(filterList.fieldIDUI)) {
        const propertyList = filterList?.sliderContents?.sliderSteps?.sliderSteps;
        const getOptionsMin = () => {
          const list = propertyList?.filter((item) => builtYear?.max > 0 ? item?.value < builtYear?.max ? item : false : item)
          ?.map((item, index) => index < propertyList.length - 1
          ? <option key={`${item.value}-builtYear-min`} value={item.value}>{item?.display ===  '1799' ? 'Before 1800' : item?.display}</option>
          : null);
          return list.slice(0, list?.length - 1)
        };
        const getOptionsMax = () => {
          const list = propertyList?.slice(1)?.filter((item) => builtYear?.min > 0 ? item?.value > builtYear?.min ? item : false : item);
          return list?.map((item) => <option key={`${item.value}-builtYear-max`} value={item.value}>{item?.display ===  '2011' ? 'After 2010' : item?.display}</option>);
        };
        FilterComponent[5] = (
          <FilterItem
            name={filterList?.name}
            key={filterList?.name}
            onChange={({ value, field }) => {
              const min = field === "min" ? Number(value) : builtYear.min;
              const max = field === "min" ? builtYear.max : Number(value);
              //update Addressbar
              let addressBarURL = new URL(window.location.href);
              if (addressBarURL.searchParams.has("yearBuiltRange")) {
                addressBarURL.searchParams.delete("yearBuiltRange");
                addressBarURL.searchParams.append(
                  "yearBuiltRange",
                  `${!min || min === 0 || min === 1799 ? "Before 1800" : min}-${
                    !max || max === 0 || max === 2011 ? "After 2010" : max
                  }`
                );
                history.pushState({}, "", addressBarURL.href);
              } else {
                addressBarURL.searchParams.append(
                  "yearBuiltRange",
                  `${!min || min === 0 || min === 1799 ? "Before 1800" : min}-${
                    !max || max === 0 || max === 2011 ? "After 2010" : max
                  }`
                );
                history.pushState({}, "", addressBarURL.href);
              }
              //update Redux
              if (field === "min") {
                if (pageNumber !== 1) dispatch(setPageNumber(1));
                dispatch(addBuiltYearMin(Number(value)));

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_year_built",
                  eventSource: "Filter select",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Year Built:${
                    !value || value === 0 || value === 1799
                      ? "Before 1800"
                      : value
                  }-${
                    !builtYear.max ||
                    builtYear.max === 0 ||
                    builtYear.max === 2011
                      ? "After 2010"
                      : builtYear.max
                  } | Location: ${getSrpLocationLabel()}`,
                });
              } else {
                if (pageNumber !== 1) dispatch(setPageNumber(1));
                dispatch(addBuiltYearMax(Number(value)));

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_year_built",
                  eventSource: "Filter select",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Year Built:${
                    !builtYear.min ||
                    builtYear.min === 0 ||
                    builtYear.min === 1799
                      ? "Before 1800"
                      : builtYear.min
                  }-${
                    !value || value === 0 || value === 2011
                      ? "After 2010"
                      : value
                  } | Location: ${getSrpLocationLabel()}`,
                });
              }
            }}
            defaultMax={2011}
            value={builtYear}
            optionsMin={getOptionsMin()}
            optionsMax={getOptionsMax()}
          />
        );
      } else if (filterList.name === "Beds" && !disabledList.includes(filterList.name)) {
        const propertyList = filterList?.facetContents?.listContents;
        FilterComponent[2] = (
          <FilterItem
            name={filterList?.name}
            key={filterList?.name}
            onChange={(value) => {
              //update Addressbar
              let addressBarURL = new URL(window.location.href);
              if (addressBarURL.searchParams.has("bed")) {
                addressBarURL.searchParams.delete('bed')
                value !== "5" && addressBarURL.searchParams.append('bed', value)
                history.pushState({}, '', addressBarURL.href)
              } else {
                value !== "5" && addressBarURL.searchParams.append('bed', value)
                history.pushState({}, '', addressBarURL.href)
              }
              //update Redux
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              if (value === "5") {
                dispatch(addBedrooms(""))
              } else {
                dispatch(addBedrooms(value))

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_beds",
                  eventSource: "Filter select",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Beds:${value} | Location: ${getSrpLocationLabel()}`,
                });
              }
            }}
            value={bedrooms}
            isSingleItem={true}
            optionsMin={propertyList?.map((item) => <option value={item?.id} key={item?.id}>{item?.displayname === "5+" ? "Any" : item?.displayname}</option>)}
          />
        )
      } else if (filterList.name === "Baths" && !disabledList.includes(filterList.name)) {
        const propertyList = filterList?.facetContents?.listContents;
        FilterComponent[3] = (
          <FilterItem
            name={filterList?.name}
            key={filterList?.name}
            onChange={(value) => {
              //update Addressbar
              let addressBarURL = new URL(window.location.href);
              if (addressBarURL.searchParams.has("bath")) {
                addressBarURL.searchParams.delete('bath')
                value !== "5" && addressBarURL.searchParams.append('bath', value)
                history.pushState({}, '', addressBarURL.href)
              } else {
                value !== "5" && addressBarURL.searchParams.append('bath', value)
                history.pushState({}, '', addressBarURL.href)
              }
              //update Redux
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              if (value === "5") {
                dispatch(addBathrooms(""))
              } else {
                dispatch(addBathrooms(value))

                // Track via API
                trackFilterInteraction('FILTER_SELECTED');

                trackButtonClick({
                  eventName: "filters_baths",
                  eventSource: "Filter select",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Baths:${value} | Location: ${getSrpLocationLabel()}`,
                });
              }
            }}
            value={bathrooms}
            isSingleItem={true}
            optionsMin={propertyList?.map((item) => <option value={item?.id} key={item?.id}>{item?.displayname === "5+" ? "Any" : item?.displayname}</option>)}
          />
        )
      }
    })
    return FilterComponent;
  }

  return (
    <li className={isMobView ? "" : "list-inline-item menu-item-container"} style={{ marginRight: isMobView ? 0 : 10 }}>
      <div id={panelId} className="panel-group">
        <div className="panel">
          <div className="panel-heading">
            <h4 className="panel-title">
              <div
                className="selectpicker w100 filter-menu"
                id={`${panelId}-btn`}
              >
                <span className={`filter-menu-title ${propertyCount > 0 ? 'filter-menu-selected' : ''}`}>
                  {propertyName}
                  {propertyCount > 0 && <span className={`${propertyCount > 0 ? 'filter-menu-count' : ''}`}> {` (${propertyCount})`}</span>}
                </span>
                <div className="filter-menu-arrow" onClick={(e) => {
                  if (propertyCount > 0) {
                    onClearPress();
                    e.stopPropagation();
                    e.preventDefault();
                  }
                }}>
                  <img src={propertyCount > 0 ? close : downArrow} className={propertyCount > 0 || show ? "arrow-up" : "arrow-down"} height="10" width="11" alt="propCount" />
                </div>
              </div>
            </h4>
          </div>
          {show && <div id={panelBodyId} className={`panel-collapse collapse ${isMobView ? '' : 'panel-model'}`} style={{display: 'block', padding: 0}}>
            <div className="panel-body row text-align-left m0" style={{width: isMobView ? '100%' : 340, padding: isMobView ? 0 : 25, paddingBottom: 0}}>
              {getFilterComponent()}
            </div>
          </div>}
        </div>
      </div>
    </li>
  );
};
export default memo(FilterMoreItem);
